import * as React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';
import { theme } from '@garnish/constants';

import { PinWrapper } from './PinWrapper';

// ─────────────────────────────────────────────────────────────────────────────

export const SelectedLocationPin = () => {
  return (
    <PinWrapper>
      <Svg width="48" height="48" fill="none" viewBox="0 0 48 48">
        <Path
          stroke={theme.colors.KALE}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M24 9v32"
        />

        <Circle cx="24" cy="17" r="10" fill={theme.colors.KALE} />
        <Circle
          cx="24"
          cy="17"
          r="10"
          stroke={theme.colors.KALE}
          stroke-width="2"
        />
      </Svg>
    </PinWrapper>
  );
};
